import React from 'react';
import Navbar from './Navbar';

class Landing extends React.Component{
    constructor(props){
        super(props);   
        this.state={
            deciding:false
        };
    }
    render(){         
        return(
            <div className="pusher" style={{backgroundColor:"#E6DCDB"}}>
            <div className="ui vertical masthead center aligned segment" style={{borderBottom:"#fff"}} >
            <Navbar active="landing" color=""/>
            <div className="ui text container">
            <img src="/decider/images/decider.svg" alt="Clover" style={{width:"150px", marginTop:"13vh"}} />
            <h1 className="ui header" style={{fontSize:"3em",marginTop:"0"}}>Decider App with React Js</h1>
            <h3 className="ui header">Tired of making decision by your own? Let us decide it for you!<br />Do you want to know if you are lucky or not? Let us calculate it for you!<br />Do you have any question? Let us answer it for you!</h3>
            <a href="/decider/#/decision">
                <button className={"ui huge button black"}>Decision Maker</button>
            </a>
            <a href="/decider/#/lucky">
                <button className={"ui huge button purple"}>Lucky Meter</button>
            </a>
            <a href="/decider/#/">
                <button className={"ui huge button disabeled"} style={{position:"relative"}}>Prophetic Question <div style={{position:"absolute",textAlign:"center",marginLeft:"auto",marginRight:"auto",fontSize:"0.5em",left:0,right:0, marginTop:"-5px"}} >under construction</div></button>
            </a>
            <h4 style={{marginTop:"10vh"}} className="ui header" >By: Ihsan Fajar Ramadhan</h4>
            </div>
            </div>
            </div>
        )
    }
}

export default Landing;